module.exports = __webpack_public_path__ + "img/icon_tag_relax.b9026f7b.svg";